// extracted by mini-css-extract-plugin
export default {"content":"ReceiptPublicContent_content__B9Boo"};